const defaultState = {
  list: [],
  item: null,
  presentations: [],
  presentations_loaded: true,
}


const folders = (state = defaultState, action) => {
  switch (action.type) {
    case 'GET_FOLDERS':
      return {...state, list: action.data}
    case 'SET_FOLDER':
      return {...state, item: action.data}
    case 'NEW_FOLDER':
      return {
        ...state, 
        list: [...state.list, action.data]
      };
    case 'NEW_FOLDER_PRESENTATION':
      return {
        ...state, 
        presentations: [...state.presentations, action.data]
      };
    case 'UPDATE_FOLDER_PRESENTATION':
      return {
        ...state, 
        presentations: state.presentations.map(item => {
          if(item.id == action.data.id){
            return action.data
          }
          return item
        }),
      };  
    case 'DELETE_FOLDER':
      return {
        ...state, 
        list: state.list.filter(item => (item.id != action.data)).map(item => ({...item})),
        item: null,
        presentations: []
      }  
    case 'UPDATE_FOLDER':
      return {
        ...state, 
        list: state.list.map(item => {
          if(item.id == action.data.id){
            return {...action.data};
          }
          return {...item};
        }),
        item: action.data
      }
    case 'GET_FOLDER_PRESENTATIONS':
      return {
        ...state,
        presentations: action.data,
        presentations_loaded: true,
      }
    case 'SET_FOLDER_PRESENTATIONS_LOADED':
      return {
        ...state,
        presentations_loaded: action.data,
      }
    case 'DELETE_FOLDER_PRESENTATION':
      return {
        ...state,
        presentations: state.presentations.filter(item => item.id != action.data) 
      }
    default:
      return state
  }
}

export default folders;


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/redux/reducers/folders.js